export { default as ErrorPage } from './ErrorPage';
export { default as SuccessPage } from './SuccessPage';
